import { makeStyles } from 'tss-react/mui'
import { colors } from '@/theme/colors.theme'

export const useStyles = makeStyles()(() => {
  return {
    point: {
      width: 10,
      height: 10,
      borderRadius: '50%',
      marginRight: 8,
      '&.dot-0 ': {
        backgroundColor: colors.primary,
      },
      '&.dot-1 ': {
        backgroundColor: colors.dark,
      },
      '&.dot-2': {
        backgroundColor: colors.darker,
      },
      '&.dot-3': {
        backgroundColor: colors.cyan,
      },
      '&.dot-4': {
        backgroundColor: colors.purpleLight,
      },
      '&.dot-5': {
        backgroundColor: colors.purple,
      },
      '&.dot-6': {
        backgroundColor: colors.pink,
      },
      '&.dot-7': {
        backgroundColor: colors.gray,
      },
      '&.dot-8': {
        backgroundColor: colors.white,
      },
      '&.dot-9': {
        backgroundColor: colors.blue,
      },
    },
    leftCell: {
      borderTopLeftRadius: '4px !important',
      borderBottomLeftRadius: '4px !important',
    },
    rightCell: {
      borderTopRightRadius: '4px !important',
      borderBottomRightRadius: '4px !important',
    },
  }
})
